import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFields from '../../components/form/fields';
import Input from '../../components/form/input';

const MARKDOWN_OPTIONS = {
    pedantic: false,
    gfm: true,
    breaks: true,
    sanitize: false,
    smartLists: true,
    smartypants: true,
    xhtml: true,
    highlight: function(code, lang) {
        const hljs = require('highlight.js');
        const language = hljs.getLanguage(lang) ? lang : 'plaintext';
        return hljs.highlight(code, { language }).value;
    },
    langPrefix: 'hljs language-', // highlight.js css expects a top-level 'hljs' class.
};

const MONTH_NAMES = [
    'jan', 'feb', 'mar', 'apr', 'mai', 'jun',
    'jul', 'aug', 'sep', 'okt', 'nov', 'des',
];

function getReportDate(inputDate, reportType, onlyFromDate) {
    const reportDate = new Date(`${inputDate}T00:00:00`);
    // console.log({ inputDate, reportDate})
    // console.log({ reportType })
    const reportDay = reportDate.getDate();
    const reportMonth = reportDate.getMonth();
    const reportYear = reportDate.getFullYear();

    if (reportType === 'day') {
        return `${reportDay}.${MONTH_NAMES[reportMonth]} ${reportYear}`;
    } else if (reportType === 'z-report') {
        return `${reportDay}.${MONTH_NAMES[reportMonth]} ${reportYear}`;
    } else if (reportType === 'month') {
        return `${onlyFromDate ? reportDay : 1} - ${util.daysInMonth(reportMonth + 1, reportYear)}.${MONTH_NAMES[reportMonth]} ${reportYear}`;
    } else if (reportType === 'year') {
        return `1.jan - 31.des ${reportYear}`;
    }
    return '';//`${reportDay}.${MONTH_NAMES[reportMonth]} ${reportYear}`;
}

@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class ReportsPrint extends Component {
  	constructor(props) {
        super(props);
        this.state = {
        };
    }

//     loadAll = async () => {
//         const { id } = this.props;
// console.log('reportPrint', { id })
//         const { saleReportStore } = this.props.stores;
//         await saleReportStore.load(id);
//     }

//     componentDidMount() {
//         this.loadAll();
//     }

    render() {
        const { userStore, saleStore } = this.props.stores;
        const { customer } = userStore;
        const { user, isAdmin } = userStore;
        const { customerIds, language = 'no' } = user;

        const darkmode = util.getNestedValue(user, 'settings.darkmode');
        const {
            reportUserDetails = [],
        } = saleStore;

        let totalByDate = {};
        let total = {
            fee: 0,
            medicine: 0,
            equipment: 0,
            other: 0,
            price: 0,
            totalBeforeTax: 0,
            vat: 0,
            total: 0,
        };
        let currentDate = '';

        return (<>
            <div class='receipt'>
                <div class='d-flex flex-column receipt'>
                    <div class='d-flex flex-row justify-content-between'>
                        <div class='text-center d-flex align-items-center'>
                            {customer.images && customer.images.length > 0 && <img src={localUtil.displayImg(customer.images[0], this.props, '220x')} class='img-fluid' style='max-height: 100px;' />}
                        </div>
                        <div class='d-flex align-items-center'>
                            <h3 class='font-weight-lighter'>{customer.name}</h3>
                        </div>
                    </div>
                    <div class='d-flex flex-row justify-content-between mt-5'>
                        <div class='col-12 d-flex flex-column align-items-end'>
                            {/* <div class='d-flex flex-row'><Text id='dyrejournal.report-date'>Report Date:</Text> {getReportDate(util.isoDate(saleReport.reportDate, false, false, true), saleReport.reportType)}</div> */}
                            {/* <div class='d-flex flex-row'><Text id='dyrejournal.responsible'>Responsible:</Text> {user.firstname} {user.lastname}</div> */}
                        </div>
                    </div>

                    <hr />

                    <div class='d-flex flex-column mt-3'>
                        <div class='w-100 d-flex flex-column'>
                            {/* <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                                {saleReport.reportType === 'day' && <>
                                    <Text id='dyrejournal.report.daily'>Daily</Text>
                                </>}
                                {saleReport.reportType === 'z-report' && <>
                                    <Text id='dyrejournal.report.z-report'>Z-Report</Text>
                                </>}
                                {saleReport.reportType === 'month' && <>
                                    <Text id='dyrejournal.report.monthly'>Monthly</Text>
                                </>}
                                {saleReport.reportType === 'year' && <>
                                    <Text id='dyrejournal.report.yearly'>Yearly</Text>
                                </>}
                            </div> */}
                            <div class={`d-flex flex-column py-3 box-container`}>
                                <div class='table-responsive'>
                                    <table class='table table-sm table-hover table-striped'>
                                        <thead>
                                            <tr>
                                                <th><Text id='dyrejournal.report.salenumber'>Sale number</Text></th>
                                                <th><Text id='dyrejournal.report.saledate'>Sale date</Text></th>
                                                <th><Text id='dyrejournal.report.customer'>Customer</Text></th>
                                                <th><Text id='dyrejournal.report.fee'>Fee</Text></th>
                                                <th><Text id='dyrejournal.report.medicine'>medicine</Text></th>
                                                <th><Text id='dyrejournal.report.equipment'>equipment</Text></th>
                                                <th><Text id='dyrejournal.report.other'>other</Text></th>
                                                <th><Text id='dyrejournal.report.price'>price</Text></th>
                                                <th><Text id='dyrejournal.report.totalBeforeTax'>totalBeforeTax</Text></th>
                                                <th><Text id='dyrejournal.report.vat'>vat</Text></th>
                                                <th><Text id='dyrejournal.report.total'>total</Text></th>
                                                <th><Text id='dyrejournal.report.paymentMethod'>paymentMethod</Text></th>
                                                <th><Text id='dyrejournal.report.employeeName'>employeeName</Text></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {reportUserDetails.map((line, index) => {
                                                const date = util.isoDate(line.saleDate, false, false, true);
                                                const isSameDate = currentDate === date;

                                                let totalForPreviousDay;
                                                if (!isSameDate && currentDate) {
                                                    totalForPreviousDay = totalByDate[currentDate];
                                                }
                                                currentDate = date;
                                                if (!totalByDate[date]) {
                                                    totalByDate[date] = {
                                                        fee: 0,
                                                        medicine: 0,
                                                        equipment: 0,
                                                        other: 0,
                                                        price: 0,
                                                        totalBeforeTax: 0,
                                                        vat: 0,
                                                        total: 0,
                                                    };
                                                }
                                                totalByDate[date].fee += line.fee;
                                                totalByDate[date].medicine += line.medicine;
                                                totalByDate[date].equipment += line.equipment;
                                                totalByDate[date].other += line.other;
                                                // if (!(line.fee || line.medicine || line.equipment || line.other)) {
                                                    totalByDate[date].price += line.price;
                                                // }
                                                totalByDate[date].totalBeforeTax += line.totalBeforeTax;
                                                totalByDate[date].vat += line.vat;
                                                totalByDate[date].total += line.total;

                                                total.fee += line.fee;
                                                total.medicine += line.medicine;
                                                total.equipment += line.equipment;
                                                total.other += line.other;
                                                // if (!(line.fee || line.medicine || line.equipment || line.other)) {
                                                    total.price += line.price;
                                                // }
                                                total.totalBeforeTax += line.totalBeforeTax;
                                                total.vat += line.vat;
                                                total.total += line.total;

                                                const saleStatus = saleStore.getSaleStatusById(line.status);
                                                const saleStatusText = saleStore.getSaleStatusById(line.status, language);
                                                const saleStatusIcon = saleStore.getSaleStatusIcon(saleStatus);
                                                const saleStatusClass = saleStore.getSaleStatusClass(saleStatus);

                                                return (<>

                                                    {/* {!isSameDate && totalForPreviousDay && <tr>
                                                        <td class='font-weight-bold' colSpan='3'><Text id='dyrejournal.report.total'>Total</Text></td>
                                                        <td class='font-weight-bold text-end'><nobr>{util.format(totalForPreviousDay.fee, 2)}</nobr></td>
                                                        <td class='font-weight-bold text-end'><nobr>{util.format(totalForPreviousDay.medicine, 2)}</nobr></td>
                                                        <td class='font-weight-bold text-end'><nobr>{util.format(totalForPreviousDay.equipment, 2)}</nobr></td>
                                                        <td class='font-weight-bold text-end'><nobr>{util.format(totalForPreviousDay.other, 2)}</nobr></td>
                                                        <td class='font-weight-bold text-end'><nobr>{util.format(totalForPreviousDay.price, 2)}</nobr></td>
                                                        <td class='font-weight-bold text-end'><nobr>{util.format(totalForPreviousDay.totalBeforeTax, 2)}</nobr></td>
                                                        <td class='font-weight-bold text-end'><nobr>{util.format(totalForPreviousDay.vat, 2)}</nobr></td>
                                                        <td class='font-weight-bold text-end'><nobr>{util.format(totalForPreviousDay.total, 2)}</nobr></td>
                                                        <td class='font-weight-bold' colSpan='2'></td>
                                                    </tr>} */}

                                                    {!isSameDate && <tr>
                                                        <td colspan='13' class='font-weight-bolder bg-primary-light'>
                                                            {util.formatDate(line.saleDate, { locale: 'nb-NO' })}
                                                        </td>
                                                    </tr>}

                                                    <tr>
                                                        <nobr>
                                                            {line.saleNumber}
                                                            <small class={`bg-glow-${saleStatusClass} text-white rounded-pill px-2 font-weight-light ms-1`}><i class={saleStatusIcon} /> {saleStatusText}</small>
                                                        </nobr>
                                                        <td>{util.formatDate(line.saleDate, { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}</td>
                                                        <td>{line.customerName}</td>
                                                        <td class='text-end'><nobr>{util.format(line.fee, 2)}</nobr></td>
                                                        <td class='text-end'><nobr>{util.format(line.medicine, 2)}</nobr></td>
                                                        <td class='text-end'><nobr>{util.format(line.equipment, 2)}</nobr></td>
                                                        <td class='text-end'><nobr>{util.format(line.other, 2)}</nobr></td>
                                                        <td class='text-end'><nobr>{util.format(line.price, 2)}</nobr></td>
                                                        <td class='text-end'><nobr>{util.format(line.totalBeforeTax, 2)}</nobr></td>
                                                        <td class='text-end'><nobr>{util.format(line.vat, 2)}</nobr></td>
                                                        <td class='text-end'><nobr>{util.format(line.total, 2)}</nobr></td>
                                                        <td>{line.paymentMethod}</td>
                                                        <td>{line.employeeName}</td>
                                                    </tr>

                                                    {/* <tr>
                                                        <td colSpan='13'>
                                                            {date}
                                                        </td>
                                                    </tr> */}
                                                </>);
                                            })}
                                            <tr>
                                                <td class='font-weight-bolder bg-success-light' colSpan='3'><Text id='dyrejournal.report.total'>Total</Text></td>
                                                <td class='font-weight-bolder bg-success-light text-end'><nobr>{util.format(total.fee, 2)}</nobr></td>
                                                <td class='font-weight-bolder bg-success-light text-end'><nobr>{util.format(total.medicine, 2)}</nobr></td>
                                                <td class='font-weight-bolder bg-success-light text-end'><nobr>{util.format(total.equipment, 2)}</nobr></td>
                                                <td class='font-weight-bolder bg-success-light text-end'><nobr>{util.format(total.other, 2)}</nobr></td>
                                                <td class='font-weight-bolder bg-success-light text-end'><nobr>{util.format(total.price, 2)}</nobr></td>
                                                <td class='font-weight-bolder bg-success-light text-end'><nobr>{util.format(total.totalBeforeTax, 2)}</nobr></td>
                                                <td class='font-weight-bolder bg-success-light text-end'><nobr>{util.format(total.vat, 2)}</nobr></td>
                                                <td class='font-weight-bolder bg-success-light text-end'><nobr>{util.format(total.total, 2)}</nobr></td>
                                                <td class='font-weight-bolder bg-success-light text-end' colSpan='2'></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class='d-flex flex-row text text-muted mt-4'>
                        <Text id='dyrejournal.print-date'>Print Date:</Text> {util.formatDate(new Date(), { hour12: false, hour: '2-digit', minute: '2-digit', locale: 'nb-NO' })}
                    </div>
                    <hr class='mt-1' />

                    <div class='d-flex flex-row justify-content-between mt-3'>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'><Text id='dyrejournal.business-register'>The Business Register</Text></div>
                                <div>{customer.orgNumber}</div>
                                <div>{customer.name}</div>
                                {customer.orgNumber2 && <div>{customer.orgNumber}</div>}
                                {customer.name2 && <div>{customer.name}</div>}
                            </small>
                        </div>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'><Text id='dyrejournal.address'>Address</Text></div>
                                <div>{customer.address}</div>
                                <div>{customer.postalcode} {customer.place}</div>
                            </small>
                        </div>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'>{customer.fax ? <Text id='dyrejournal.phone-fax'>Phone/Fax</Text> : <Text id='dyrejournal.phone'>Phone</Text>}</div>
                                <div>{customer.phone}</div>
                                {customer.fax ? <div>{customer.fax}</div> : null}
                            </small>
                        </div>
                        <div class='d-flex flex-column'>
                            <small>
                                <div class='mb-2 font-weight-bold'><Text id='dyrejournal.internett'>Internet</Text></div>
                                <div>{customer.url}</div>
                                <div>{customer.email}</div>
                            </small>
                        </div>
                    </div>

                </div>

            </div>
        </>);
    }
}

export default ReportsPrint;
